import Link from 'next/link';
import { Card, CardContent, styled } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Box, Typography } from '@/primitives';

export const SaleStyledCard = styled(Card)(({ theme }) => ({
  padding: '16px',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '8px',
  overflow: 'hidden',
  boxShadow: `0 0 8px ${alpha(theme.palette.common.black, 0.1)}`,
  border: `1px solid ${(theme.vars ?? theme).palette.divider}`,
  [theme.breakpoints.down('sm')]: {
    padding: '12px 16px',
    borderRadius: 0,
    boxShadow: 'none',
    border: 'none',
    borderBottom: `1px solid ${(theme.vars ?? theme).palette.divider}`,
  },
}));

export const SaleCardNameLink = styled(Link)(({ theme }) => ({
  display: '-webkit-box',
  lineClamp: 2,
  overflow: 'hidden',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  wordBreak: 'break-word',
  textOverflow: 'ellipsis',
  color: (theme.vars ?? theme).palette.info.main,
  fontSize: '18px',
  fontWeight: 500,
  textDecoration: 'none',
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px',
  },
}));

export const SaleCardCell = styled(Box)({
  width: 'calc(50% - 8px)',
  display: 'flex',
  flexDirection: 'column',
  minHeight: '44px',
});

export const SaleCardPropsHeader = styled(Typography)(({ theme }) => ({
  color: (theme.vars ?? theme).palette.text.secondary,
  fontSize: '14px',
  lineHeight: '16px',
}));

export const SaleCardPropsValue = styled(Box)(({ theme }) => ({
  display: '-webkit-box',
  lineClamp: 1,
  overflow: 'hidden',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 1,
  wordBreak: 'break-word',
  textOverflow: 'ellipsis',
  color: (theme.vars ?? theme).palette.text.primary,
  fontSize: '16px',
  lineHeight: '20px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
    lineHeight: '18px',
  },
}));

export const SaleFieldGrid = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  columnGap: '16px',
  rowGap: '4px',
});

export const SaleCardGrid = styled(CardContent)({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  columnGap: '16px',
  rowGap: '4px',
  padding: 0,
  '&:last-child': { paddingBottom: 0 },
});
